import React from 'react';
import styles from './SleepScreenVideoPreview.module.css';

const SleepScreenVideoPreview = ({ url }) => {
  if (!url) return null;
  return (
    <video
      key={url}
      className={styles.video}
      src={url}
      muted
      preload="metadata"
      controls
    />
  );
};

export default SleepScreenVideoPreview;
